import { render, staticRenderFns } from "./properties-block-title.vue?vue&type=template&id=09c1a88d&scoped=true"
import script from "./properties-block-title.vue?vue&type=script&lang=js"
export * from "./properties-block-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c1a88d",
  null
  
)

export default component.exports